<script>

export default {
  name: 'AreaLink',
  props: {
    item: {
      type: Object,
      required: true
    },
  }
}
</script>
<template>
  <router-link :to="`/properties/${this.item.property_id}/areas/${this.item.id}`" class="btn-link">
    {{ this.item.name }} ({{ this.item.items.length }} items)
  </router-link>
</template>